<template>
    <div id="app">
        <transition :name="transitionName">
            <router-view />
        </transition>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            transitionName: ""
        };
    },
    watch: {
        $route(to, from) {
            if (to.meta.index > from.meta.index) {
                this.transitionName = "slide-left";
            } else if (to.meta.index < from.meta.index) {
                this.transitionName = "slide-right";
            } else {
                this.transitionName = "";
            }
        }
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue